module.exports = __webpack_public_path__ + "images/c37fc0eda62932a221ea2fbdecd429ce-trendingImg3.png";